<template>
   <div >
    <page-header title="사용자 관리" description="사용자 추가입니다." :isBack="true">

    </page-header>
    <div class="page-body pt-30 ph-30">
      <div class="box mt-20">
        <div class="box-header">
          <h3>사용자 추가</h3>
        </div>
        <div class="box-body">
          <form action="">
            <!--div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">사용자</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text"  v-model="data.userName" class="form-control form-control-success">
              </div>
            </div-->
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">사용자</span>
              </label>
              <div class="col-6 pt-2">
                <multiselect :value="nameValue" v-model="selectedItem" :options="empList" :custom-label="searchLabel" placeholder="임직원검색" track-by="empEmail"
                deselect-label="취소"
                select-label="선택"
                :preserve-search="true"
                :searchable="true" :internal-search="false" :clear-on-select="false" @search-change="asyncFind"

                >
                  <template slot="singleLabel" slot-scope="{ option }"><div class="single-select-label">{{ option.empName }} [{{option.empTeam}}][{{option.empEmail}}]</div></template>
                  <span slot="noResult">결과가 없습니다.</span>
                  <span slot="noOptions">목록이 없습니다.</span>
              </multiselect>
              </div>
            </div>
            <!--div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">사번</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" v-model="data.empNo"  class="form-control form-control-success">
              </div>
            </div-->
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">사용자타입</span>
              </label>
              <div class="col-8 pt-2">
                <div class="input-group align-top">
                  <dropdown v-model="userLevelCode" :datasource="getUserLevelList" displayName="userLevelStr"
                  :isSelectionFirstData="true"
                  valueName="userLevelCode" placeholder="IDC 권한 " :isAuto="true"/>
                </div>
              </div>
            </div>
             <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">IDC 권한</span>
              </label>
              <div class="col-8 pt-2">
                <div class="input-group align-top">
                  <dropdown v-model="checkBox" :datasource="idcList" displayName="locationName"
                  valueName="locationCode" placeholder="IDC 권한 " :showCheckbox="true" :isMultiple="true"  :isAuto="true"
                  @checkBoxChange="checkBoxChange"/>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">주 IDC</span>
              </label>
              <div class="col-8 pt-2">
                <div class="input-group align-top">
                  <dropdown v-model="mainIdc" :datasource="checkedIdcList" displayName="locationName"
                  valueName="locationCode" placeholder="IDC 권한 " :isAuto="true"/>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="btn-wrap mt-30 justify-content-center">
        <button class="btn btn-lg line-2" @click="list()">목록</button>
        <button class="btn btn-lg blue" @click="save()">저장</button>
      </div>
    </div>
   </div>
</template>

<script>
import Dropdown from "@/components/Dropdown.vue"
import PageHeader from '@/layout/PageHeader.vue';
import Multiselect from 'vue-multiselect'
export default {
  components: { Dropdown, PageHeader, Multiselect},
  data(){
    return {
      idcList: [],
      formIdcList: [],
      data: {userName: null, empNo: null},
      checkedIdcList: null,
      userLevelCode: null,
      mainIdc: null,
      nameValue: null,
      selectedItem: null,
      empList: [],
    }
  },
  mounted(){
    this.init();
  },
  computed: {
    getUserLevelList(){
      return this.$store.getters['dropdown/dataprovider'].userLevel.filter(data => data.userLevelCode <= this.$store.state.login.userLevel)
    },
    /*
    checkedIdcList() {
      debugger;
      return this.idcList.filter(x=>x.checked);
    }
    */
  },
  methods: {
    init(){
      this.loadIdc();
    },
    checkBoxChange(data){
      this.checkedIdcList = this.idcList.filter(x=>x.checked);
    },
    loadIdc(){
      var that = this;
      this.$http.get('/api/private/location/list').then((result) =>{
        that.idcList = _.uniqBy(result.data.map(x=>{return {locationCode: x.code[0], locationName: x.str[0]}}),  e=>e.locationCode);
        //idcList = idcList.concat(that.copyNew(that.formIdcList));
        //that.idcList = idcList;
      })
    },
    loadItem(){
      this.$http.get('/app/').then((result)=>{

      })
    },
    save(){

      var that = this;
      var userIdcAuthList = [];
      var updateIdcList =  this.copyNew(this.idcList);

      updateIdcList.filter(x=>x.checked).forEach(x=>{
        x.isDefault  = x.locationCode == that.mainIdc ? 1 : 0;
        var o = {empNo: that.selectedItem.empNo, locationCode: x.locationCode, isDefault: x.isDefault};
        userIdcAuthList.push(o);
      })


      var o = {
        empName: this.selectedItem.empName,
        empNo: this.selectedItem.empNo,
        userIdcAuthList: userIdcAuthList,
        userLevelCode : this.userLevelCode
      }
      this.$http.post('/api/private/user', o)
        .then((result) => {
          that.$toast.success('사용자 추가');
          this.$router.push({ path: '/app/user', query: {mode: 'list'}})
        }).catch((e) =>{
          console.log(e);
          this.noti('실패', e.response.data.message, 'warning');
      })

      //this.$router.push({ path: '/app/user', query: {mode: 'list'}})
    },
    list(){
      this.$router.push({ path: '/app/user', query: {mode: 'list'}})
    },
    searchLabel ({ empName, empTeam, empEmail }) {
      return `${empName} [${empTeam}][${empEmail}]`
    },
    asyncFind(query){
      if(query == ''){
        this.selectedItem = null;
        this.empList = [];
        return;
      }
      if(query.length < 2) {
        return;
      }
      var that = this;
      this.$http.get('/api/private/emp/search'+'?empName='+ query)
        .then((result) => {
          that.empList = _.uniqBy(result.data, x => x.empEmail);
        }).catch((e) =>{
      })
    },
  }
}
</script>

<style>

</style>
